<script setup></script>

<template>
  <svg height="24" fill="currentColor" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12,8.45A3.55,3.55,0,1,0,15.55,12,3.55,3.55,0,0,0,12,8.45Zm0,5.1A1.55,1.55,0,1,1,13.55,12,1.56,1.56,0,0,1,12,13.55Zm9.37-2.05c-.15-.26-3.75-6.45-9.37-6.45S2.78,11.24,2.63,11.5a1,1,0,0,0,0,1C2.78,12.76,6.38,19,12,19s9.22-6.19,9.37-6.45A1,1,0,0,0,21.37,11.5ZM12,17C8.36,17,5.59,13.34,4.68,12,5.59,10.65,8.35,7.05,12,7.05s6.41,3.61,7.32,5C18.41,13.35,15.65,17,12,17Z"
    />
  </svg>
</template>
